import React from 'react';
import { REWARDS_LEVEL_COLOR } from '../PlacePerkConstants';

const SmallStar = ({ perkLevel }) => {
  const fillColor = REWARDS_LEVEL_COLOR[perkLevel];
  return (
    <span // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `
      <svg
        width="18"
        height="18"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM7.50001 3.5C7.69387 3.5 7.87026 3.61206 7.95263 3.78755L8.92087 5.85035L11.0755 6.17933C11.2607 6.20761 11.4146 6.33713 11.4741 6.51485C11.5336 6.69257 11.4888 6.88864 11.3579 7.02278L9.78412 8.63573L10.1567 10.9195C10.1875 11.1085 10.1077 11.2985 9.95121 11.4087C9.79468 11.519 9.58892 11.5302 9.42134 11.4376L7.50001 10.3755L5.57868 11.4376C5.41111 11.5302 5.20534 11.519 5.04881 11.4087C4.89228 11.2985 4.81248 11.1085 4.84331 10.9195L5.2159 8.63573L3.64214 7.02278C3.51126 6.88864 3.46638 6.69257 3.52588 6.51485C3.58539 6.33713 3.73928 6.20761 3.92454 6.17933L6.07916 5.85035L7.04739 3.78755C7.12976 3.61206 7.30615 3.5 7.50001 3.5Z"
        fill="${fillColor}"
      />
    </svg>
      `,
      }}
    />
  );
};

export default SmallStar;
